export const QUESTIONNAIRE_USER_SAVE_LIMIT = 5;

export const QUESTIONNAIRE_REVISION_REASONS = {
  USER_SAVE: 'user_save',
  AUTO_SAVE: 'auto_save',
  AI_SAVE: 'ai_save',
};
